<template>
  <ui-report-panel title="Quotes" :filters="filters" :fetch="fetch" @filtersChanged="({ refresh }) => refresh()">
    <template #actions="{ report }">
      <div class="flex items-baseline space-x-6">
        <div>
          <span class="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
          <span class="text-xs font-semibold text-gray-500">Viewed <span class="text-gray-400">(Responses Not Supported)</span></span>
        </div>
        <span class="text-xs font-semibold text-gray-500">{{ report.length }} Sent</span>
      </div>
    </template>
    <template #default="{ report }">
      <ui-table v-if="report && report.length > 0" :headers="['', 'Reference', 'Package', 'Date', 'From','To','Sub-Total','Markup','Estimated Profit','Total']" v-slot="{ cellClass }" compact>
        <tr v-for="remoteFile in parseReport(report, filters)" :key="`${remoteFile.id}-${remoteFile.closed_at ? 'closed' : 'opened'}`" class="hover:bg-blue-50 cursor-pointer" @click="goTo(remoteFile.entity._links.classic.view)">
          <td :class="cellClass" @click="$event.stopPropagation()">
            <input
              type="checkbox"
              class="h-4 w-4 rounded text-blue-500 border-gray-500 focus:border-blue-400 focus:ring-offset-0 focus:ring focus:ring-blue-300 focus:ring-opacity-50 transition"
              :value="remoteFile.id"
              v-model="selectedInviteIds"
              @click="$event.stopPropagation()"
            >
          </td>
          <td :class="cellClass">
            <reports-sent-estimates-status-dot class="mr-2" :remote-file="remoteFile"></reports-sent-estimates-status-dot>
            {{ remoteFile.entity.reference }}
          </td>
          <td :class="cellClass" class="font-medium text-gray-900">
            <span class="truncate">
              {{ remoteFile.entity.full_package_name | truncate(40) }}
            </span>
          </td>
          <td :class="cellClass">
            {{ remoteFile.emailed_at }}
          </td>
          <td :class="cellClass">
            {{ remoteFile.invited_by }}
          </td>
          <td :class="cellClass">
            <span class="truncate">
              {{ remoteFile.email | truncate(20) }}
            </span>
          </td>
          <td :class="cellClass" class="text-right">
            &pound;{{ remoteFile.entity.costs.subtotal | toCurrency(false) }}
          </td>
          <td :class="cellClass" class="text-right">
            {{ remoteFile.entity.costs.markup | toCurrency(false) }}%
          </td>
          <td :class="cellClass" class="text-right">
            &pound;{{ remoteFile.entity.costs.estimated_profit | toCurrency(false) }}
          </td>
          <td :class="cellClass" class="text-right">
            &pound;{{ remoteFile.entity.costs.total | toCurrency(false) }}
          </td>
        </tr>
      </ui-table>
      <div v-else class="px-4 py-16 text-center text-gray-400">
        There has been no sent quotes within the parameters you searched for...
      </div>
    </template>
  </ui-report-panel>
</template>

<script>
import { RemoteInvite } from '@models'

export default {
  props: {
    filters: Object,
    parseReport: Function,
  },
  data () {
    return {
      invites: [],
      selectedInviteIds: [],
    }
  },
  computed: {
    selectedInvites () {
      return this.invites.filter(({ id }) => this.selectedInviteIds.includes(id))
    },
  },
  methods: {
    async fetch (filters) {
      const invites = await RemoteInvite.allWithActivity({ ...filters, type: 'quote' })
      this.invites = invites
      this.selectedInviteIds = invites.map(({ id }) => id)
      return invites
    },
    goTo (url) {
      window.location = url
    },
  },
  watch: {
    selectedInvites (invites) {
      this.$emit('update:count', invites.length)
      this.$emit('update:sum', invites.reduce((acc, invite) => acc + invite.entity.cf_total, 0))
    },
  }
}
</script>
